import { useState } from "react";
// import { Col } from "reactstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import { SidebarLinks } from "./SidebarLinks";
import Logo from "../../../assets/images/logo.jpeg";
/**
 * Sidebar Component for the app
 *
 * @returns {JSX.Element}
 */
export default function Sidebar() {
  return <h1>Nav bar</h1>;
}
